var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 3.73715H11.4414",
    stroke: "#767676",
    strokeWidth: 0.908397,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.30859 5.69495L3.41891 11.8017C3.53175 12.4223 4.07227 12.8733 4.70304 12.8733H7.74517C8.37596 12.8733 8.9165 12.4222 9.02934 11.8017L10.1396 5.69495",
    stroke: "#767676",
    strokeWidth: 0.908397,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.26172 2.43187C4.26172 1.71105 4.84607 1.12671 5.56689 1.12671H6.87207C7.59292 1.12671 8.17725 1.71105 8.17725 2.43187V3.73703H4.26172V2.43187Z",
    stroke: "#767676",
    strokeWidth: 0.908397,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionDelete);
export default __webpack_public_path__ + "static/media/sectionDelete.8ce4806511bcde2bf9ebe727806514eb.svg";
export { ForwardRef as ReactComponent };